// Constrói o item top-level "Workspace" da sidebar (26/08, decisão Ivan —
// antes era só "Tarefas"): agrupa Tarefas (quadros Trello/Monday), Mapas
// (canvas mental/workflow estilo Miro) e Drive (arquivos no storage vendido).
// Pura: recebe `t` (i18n) e `accountScopedRoute` (monta o `to` com o accountId corrente).
export function buildTasksMenu({ t, accountScopedRoute }) {
  return {
    name: 'Workspace',
    label: t('SIDEBAR.WORKSPACE'),
    icon: 'i-lucide-layout-dashboard',
    children: [
      {
        name: 'TASKS',
        label: t('SIDEBAR.TASKS'),
        icon: 'i-lucide-square-kanban',
        to: accountScopedRoute('tasks_boards_index'),
        activeOn: ['tasks_boards_index', 'tasks_board_view'],
      },
      // Chat de IA (AI Studio) mora aqui desde 27/08 (decisão Ivan): é
      // ferramenta de trabalho interna, como Tarefas/Mapas/Drive.
      {
        name: 'AiStudio',
        label: t('AI_STUDIO.MENU_TITLE'),
        icon: 'i-lucide-message-square-more',
        to: accountScopedRoute('ai_studio_index'),
        activeOn: ['ai_studio_index'],
      },
      {
        name: 'WorkspaceMaps',
        label: t('SIDEBAR.WORKSPACE_MAPS'),
        icon: 'i-lucide-git-fork',
        to: accountScopedRoute('planning_maps_index'),
        activeOn: ['planning_maps_index', 'planning_map_view'],
      },
      // ChatSuite Pages (decisão Ivan 29/08): mora no Workspace.
      {
        name: 'MarketingPages',
        label: t('SIDEBAR.MARKETING_PAGES'),
        icon: 'i-lucide-panels-top-left',
        to: accountScopedRoute('marketing_pages'),
        activeOn: ['marketing_pages'],
      },
      {
        name: 'WorkspaceDrive',
        label: t('SIDEBAR.WORKSPACE_DRIVE'),
        icon: 'i-lucide-hard-drive',
        to: accountScopedRoute('workspace_drive_index'),
        activeOn: ['workspace_drive_index'],
      },
    ],
  };
}
